import { Button } from '@mui/material'
import { t } from 'i18next'
import { useState } from 'react'

import { useGlobalContext } from '../../Shared/Contexts/GlobalContext.jsx'
import ZDialog from '../../Shared/Dialogs/ZDialog.jsx'
import { useOrganizationProfiles } from '../Contexts/OrganizationProfilesContext.jsx'
import OrganizationProfileForm from '../Forms/OrganizationProfileForm.jsx'

const EditOrganizationProfile = ({ isOpen, profile, onClose }) => {
  const { useUpdateOrganizationProfile } = useOrganizationProfiles()
  const { openErrorAlert, openSuccessAlert } = useGlobalContext()
  
  const [formData, setFormData] = useState(null)
  const [validation, setValidation] = useState({ isValid: false })

  const handleFormChange = ({ data, validation: formValidation }) => {
    setFormData(data)
    setValidation(formValidation)
  }

  const handleSave = () => {
    if (!formData || !validation.isValid || !profile) return

    const payload = {
      name: formData.name,
      maxDevicesCount: parseInt(formData.maxDevicesCount),
      maxOrganizationsCount: parseInt(formData.maxOrganizationsCount),
      maxCallsPerMonthCount: parseInt(formData.maxCallsPerMonthCount),
      dataRetentionPolicyInDays: parseInt(formData.dataRetentionPolicyInDays)
    }

    useUpdateOrganizationProfile(profile.id, payload)
      .then(() => {
        onClose()
        openSuccessAlert()
      })
      .catch((err) => openErrorAlert({ keys: err.keys || [] }))
  }

  const handleClose = () => {
    setFormData(null)
    setValidation({ isValid: false })
    onClose()
  }

  return (
    <ZDialog
      id="edit-organization-profile-dialog"
      isOpen={isOpen}
      onClose={handleClose}
      title={t('organizationProfiles.edit')}
      content={
        <OrganizationProfileForm
          profile={profile}
          onChange={handleFormChange}
        />
      }
      actions={
        <Button
          id="update-organization-profile-button"
          variant="contained"
          color="primary"
          onClick={handleSave}
          disabled={!validation.isValid}
          sx={{ marginTop: 3 }}>
          {t('common.confirmAndSave')}
        </Button>
      }
      centerActions={true}
    />
  )
}

export default EditOrganizationProfile
